import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { NotebookPen } from "lucide-react";

export default function CatatanPengasuh({ santriId }) {
  const { hasPerm } = useAuth();
  const qc = useQueryClient();
  const [isi, setIsi] = useState("");
  const { data: notes = [] } = useQuery({ queryKey: ["catatan", santriId], queryFn: async () => (await api.get(`/santri/${santriId}/catatan`)).data });
  const mut = useMutation({
    mutationFn: async () => api.post(`/santri/${santriId}/catatan`, { isi }),
    onSuccess: () => { toast.success("Catatan tersimpan"); setIsi(""); qc.invalidateQueries({ queryKey: ["catatan", santriId] }); },
    onError: (e) => toast.error(errMsg(e)),
  });
  return (
    <div className="glass rounded-2xl p-5 space-y-4" data-testid="catatan-pengasuh">
      <h3 className="font-semibold text-emerald-900 dark:text-emerald-100 flex items-center gap-2"><NotebookPen className="h-4 w-4 text-amber-600" /> Catatan Pembimbing ({notes.length})</h3>
      {hasPerm("catatan.write") && (
        <div className="space-y-2">
          <Textarea data-testid="catatan-input" placeholder="Tulis observasi / catatan personal untuk santri ini..." value={isi} onChange={(e) => setIsi(e.target.value)} className="bg-white/70 dark:bg-white/5 rounded-xl" />
          <Button data-testid="catatan-submit" disabled={!isi.trim() || mut.isPending} onClick={() => mut.mutate()} className="bg-amber-600 hover:bg-amber-700 text-white rounded-xl">Simpan Catatan</Button>
        </div>
      )}
      <div className="space-y-2">
        {notes.map((n) => (
          <div key={n.id} className="bg-white/60 dark:bg-white/5 rounded-xl p-3 border-l-4 border-amber-400" data-testid={`catatan-row-${n.id}`}>
            <p className="text-sm text-emerald-950 dark:text-emerald-50 whitespace-pre-wrap">{n.isi}</p>
            <p className="text-xs text-slate-400 mt-1">{n.oleh} · {new Date(n.created_at).toLocaleString("id-ID")}</p>
          </div>
        ))}
        {notes.length === 0 && <p className="text-sm text-slate-400 text-center py-3">Belum ada catatan pengasuh.</p>}
      </div>
    </div>
  );
}
